
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoKfz24SmallSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 20"><g fill="none" fill-rule="evenodd"><path fill="#FEFEFE" d="M100 9.5V1.3h-7L88.5 7c0-1-.4-2-1-3-.7-1-1.6-1.6-2.8-2-1-.5-2.3-.7-4-.7-1.5 0-2.8.2-3.8.6C75.7 2.3 75 3 74 4c-.4.6-.7 1.4-1 2.3l-1-.6c-1-.7-2.5-1-4.3-1-2 0-3.5.4-4.8 1.3V1.5H49v4.8c-.3 0-.5-.3-.8-.4-1-.7-2.6-1-4.4-1-1.6 0-3 .3-4.2 1v-.8h-2V0L29 4.3v1h-5.7l.6-3.5-2.6-.3-3.6-.2c-1 0-2 0-2.8.4-.8.4-1.4 1-2 1.5-.3.6-.6 1.2-.8 2H8.5V1.5H0v18.2h32.7l2 .2c1 0 2-.2 3.2-.5l2-.4c1 .6 2.3 1 4 1 1.8 0 3.3-.4 4.5-1l.5-.3v1h14.2v-1l.7.4c1 .6 2.3 1 4 1 2 0 3.4-.4 4.5-1v.7h16v-2.5H92v2.5h8v-2.5h1.5V9.5H100z" mask="url(#b)"/><path fill="#184287" d="M2.5 4h4v7L9 8h4.7l-3.5 3.4 3.7 6.4H9.6l-2-4L6.5 15v2.6h-4M18 7.5h1.8V10H18v7.3h-3.7V6l.6-1.2c0-.3.5-.5 1-.7.3-.3 1-.4 1.7-.4s2 0 3.3.2L20.6 6h-2.1c-.2.3-.3.4-.3.7v.8m3.1.2h9V10l-5 5h5.3v2.5H21V15l4.6-4.8h-4.3M31.6 14c0 1 0 2 .3 2.4 0 .4.5.8 1 1 .3.3 1 .4 2 .4.8 0 1.6 0 2.5-.3l-.2-2.6H36c-.2 0-.4 0-.5-.2l-.2-.8v-3.4h2V7.8h-2V4l-3.7 2v8zm14.1-2.6c0-.7-.3-1.2-.6-1.5-.2-.4-.6-.6-1-.6-.7 0-1.2.2-1.5.7-.3.4-.4.8-.5 1.4h3.7zm3.8 1.8H42c0 .6.3 1 .5 1.4.4.4.8.6 1.4.6.3 0 .6 0 1-.3l.6-.7 3.7.3c-.6 1-1.3 1.7-2 2-.8.6-2 .8-3.5.8-1.2 0-2.3-.2-3-.6-.7-.3-1.3-1-1.8-1.7s-.8-1.6-.8-2.7c0-1.5.5-2.8 1.5-3.7 1-1 2.3-1.4 4-1.4 1.4 0 2.5.2 3.3.6.8.4 1.4 1 2 2 .3.7.5 1.7.5 3v.4zm2 4.4h3.7V7.8h-3.7v9.8zm0-11h3.7V4h-3.7v2.6zm5.5 11h4V4h-4m12.7 7.4c0-.7-.3-1.2-.6-1.5-.2-.4-.6-.6-1-.6-.7 0-1.2.2-1.6.7l-.4 1.4h3.7zm3.8 1.8H66c0 .6.2 1 .5 1.4.3.4.8.6 1.4.6.3 0 .6 0 1-.3 0-.2.4-.4.6-.7l3.7.3c-.6 1-1.3 1.7-2 2-1 .6-2 .8-3.5.8-1.3 0-2.3-.2-3-.6-.8-.3-1.4-1-2-1.7-.3-.7-.6-1.6-.6-2.7 0-1.5.5-2.8 1.5-3.7 1-1 2.3-1.4 4-1.4 1.4 0 2.5.2 3.3.6.8.4 1.4 1 1.8 2 .5.7.7 1.7.7 3v.4z" mask="url(#b)"/><path fill="#EF7D00" d="M86 17.3H75c0-1 .5-2.2 1-3 .8-1 2-2.3 3.8-3.6 1-.8 1.8-1.4 2-2 .4-.3.5-.7.5-1 0-.5 0-.8-.4-1-.4-.4-.8-.5-1.3-.5-.4 0-.8 0-1 .4-.4.3-.6.8-.7 1.6L75.2 8c.2-1.2.5-2 .8-2.6.4-.6 1-1 1.7-1.3.7-.3 1.7-.4 3-.4s2.3 0 3 .4c.7.3 1.3.8 1.7 1.4.4.6.6 1.3.6 2 0 1-.2 1.7-.7 2.5-.4.6-1.3 1.4-2.6 2.3-.7.6-1.2 1-1.5 1l-1 1h6v3zm8.5-5.3V7.5L91 12h3.5zm0 2.8h-6.8v-3l6.8-8.2h3.2V12h1.7v2.8h-1.7v2.5h-3.2v-2.5z" mask="url(#b)"/></g></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoKfz24SmallSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
